import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from './environments/environment';

registerLicense(environment.SYNCFUSION_LICENSE);


import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';



if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
